import React, { useState } from 'react';

const SellingPage = ({ setActiveTab }) => {
  const [propertyAddress, setPropertyAddress] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [estimatedValue, setEstimatedValue] = useState('');

  const propertyTypes = [
    'Casa', 'Apartamento', 'Condominio', 'Terreno', 'Comercial', 'Finca'
  ];

  return (
    <div className="selling-container">
      <div className="selling-header">
        <h1>Vende tu Propiedad con Tecnología Avanzada</h1>
        <p>Maximiza el valor de tu propiedad con nuestras herramientas inteligentes</p>
      </div>

      {/* AI Valuation Highlight */}
      <div className="ai-highlight-section">
        <div className="ai-highlight-card">
          <div className="ai-highlight-content">
            <h2>🤖 Valuación Inteligente con IA</h2>
            <p>
              Nuestra inteligencia artificial analiza miles de transacciones recientes, 
              tendencias del mercado y características únicas de tu propiedad para 
              darte una valuación precisa y actualizada.
            </p>
            <div className="ai-benefits">
              <div className="benefit-item">✅ Valuación precisa en tiempo real</div>
              <div className="benefit-item">✅ Análisis de mercado completo</div>
              <div className="benefit-item">✅ Estrategias de precio optimizadas</div>
              <div className="benefit-item">✅ Identificación de compradores potenciales</div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Property Info (Formspree lead capture) */}
      <div className="property-info-section">
        <h2>Información Básica de tu Propiedad</h2>
        <p>Completa estos datos para una evaluación inicial:</p>

        <form
          action="https://formspree.io/f/meovonqz"
          method="POST"
          className="property-form"
        >
          {/* Identify this form in your inbox */}
          <input type="hidden" name="_subject" value="Evaluación de Propiedad - Link Real Estate" />
          <input type="hidden" name="form_name" value="property_info" />
          {/* Optional redirect */}
          {/* <input type="hidden" name="_next" value="https://tusitio.com/gracias" /> */}

          <div className="form-group">
            <label htmlFor="propertyAddress">Dirección de la Propiedad</label>
            <input
              type="text"
              id="propertyAddress"
              name="propertyAddress"
              placeholder="Ej: San José, Escazú, Condominio Los Laureles"
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="propertyType">Tipo de Propiedad</label>
            <select
              id="propertyType"
              name="propertyType"
              className="form-select"
              required
            >
              <option value="">Seleccionar tipo</option>
              {propertyTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="landSize">Metros Cuadrados Terreno</label>
            <input
              type="text"
              id="landSize"
              name="landSize"
              placeholder="Ej: 250"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="constructionSize">Metros Cuadrados Construcción</label>
            <input
              type="text"
              id="constructionSize"
              name="constructionSize"
              placeholder="Ej: 125"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="fincaPlano">Número de Finca o Plano</label>
            <input
              type="text"
              id="fincaPlano"
              name="fincaPlano"
              placeholder="Ej: G-380480-2020 o 5-34788-000"
              className="form-input"
            />
          </div>

          <button type="submit" className="button-primary form-submit-btn">
            Obtener Evaluación Gratuita
          </button>
        </form>
      </div>

      {/* Selling Process */}
      <div className="selling-process-section">
        <h2>Nuestro Proceso de Venta Inteligente</h2>
        <div className="process-steps">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3>Análisis IA</h3>
            <p>Nuestra IA analiza tu propiedad y el mercado para determinar el precio óptimo</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">2</div>
            <h3>Marketing Digital</h3>
            <p>Creamos campañas personalizadas para llegar a los compradores ideales</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">3</div>
            <h3>Matching Inteligente</h3>
            <p>Conectamos tu propiedad con compradores que buscan exactamente lo que ofreces</p>
          </div>
          
          <div className="step-card">
            <div className="step-number">4</div>
            <h3>Cierre Eficiente</h3>
            <p>Te acompañamos en todo el proceso legal y administrativo</p>
          </div>

          <div className="step-card">
            <div className="step-number">5</div>
            <h3>Prestamos de venta</h3>
            <p>Te ayudamos a conseguir creditos de liquidez mientras consigues una mejor oferta</p>
            <p>Nos duele verte aceptar una oferta suboptima por temas de liquidez</p>
          </div>

        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2>¿Por qué vender con Link Real Estate?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">📈</div>
            <h3>Mejor Precio</h3>
            <p>Nuestra IA optimiza el precio para maximizar tu ganancia</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">⚡</div>
            <h3>Venta Más Rápida</h3>
            <p>Encontramos compradores calificados en menos tiempo</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">🎯</div>
            <h3>Marketing Preciso</h3>
            <p>Llegamos exactamente a quienes buscan tu tipo de propiedad</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">🤝</div>
            <h3>Soporte Completo</h3>
            <p>Te acompañamos desde la valuación hasta el cierre</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>¿Listo para vender tu propiedad?</h2>
          <p>Comienza con una consulta gratuita con nuestro asistente IA</p>
          <button 
            className="button-primary cta-btn"
            onClick={() => setActiveTab('contact')}
          >
            Contactanos
          </button>
        </div>
      </div>
    </div>
  );
};

export default SellingPage;
